import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import {
  au
} from "@/firebase/init";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home,
  },
  // Admin Router
  {
    path: "/admin",
    name: "Admin",
    component: () => import( /* webpackChunkName: "admin" */ "../views/admin/Admin.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // App Router
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/menu",
    name: "Menu",
    component: () => import( /* webpackChunkName: "menu" */ "../views/Menu.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import( /* webpackChunkName: "contact" */ "../views/Contact.vue"),
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: () => import( /* webpackChunkName: "gallery" */ "../views/Gallery.vue"),
  },
  {
    path: "/shorts",
    name: "Shorts",
    component: () => import( /* webpackChunkName: "shorts" */ "../views/Products/Shorts.vue"),
  }, {
    path: "/caps",
    name: "Caps",
    component: () => import( /* webpackChunkName: "caps" */ "../views/Products/Caps.vue"),
  }, {
    path: "/sweaters",
    name: "Sweaters",
    component: () => import( /* webpackChunkName: "sweaters" */ "../views/Products/Sweaters.vue"),
  }, {
    path: "/jackets",
    name: "Jackets",
    component: () => import( /* webpackChunkName: "jackets" */ "../views/Products/Jackets.vue"),
  },
  {
    path: "/account",
    name: "Account",
    component: () => import( /* webpackChunkName: "account" */ "../views/Account.vue"),
  },
  {
    path: "/help",
    name: "Help",
    component: () => import( /* webpackChunkName: "help" */ "../views/Help.vue"),
  },
  {
    path: "/facebook",
    name: "Facebook",
    component: () => import( /* webpackChunkName: "facebook" */ "../views/Facebook.vue"),
  },
  {
    path: "/advert",
    name: "Advert",
    component: () => import( /* webpackChunkName: "stationary" */ "../views/Advert.vue"),
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Default scroll position will be 0, 0 unless overridden by a saved position
    const position = {
      x: 0,
      y: 0
    };

    // Override default with saved position (if it exists)
    if (savedPosition) {
      position.x = savedPosition.x;
      position.y = savedPosition.y;
    }

    // Listen for scrollBeforeEnter event and set scroll position
    return new Promise(resolve => {
      this.app.$root.$once("scrollBeforeEnter", () => {
        resolve(position);
      });
    });
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((rec) => rec.meta.requiresAuth)) {
    let user = au.currentUser;
    if (user) {
      next();
    } else {
      next({
        name: "Account",
      });
    }
  } else {
    next();
  }
});

export default router;